var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNum2White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.83 229.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,229.18v-36.38l79.57-61.21c4.98-3.85,10.08-8.16,15.3-12.92,5.21-4.76,10.03-9.91,14.45-15.47,4.42-5.55,8.04-11.5,10.88-17.85,2.83-6.34,4.25-13.14,4.25-20.4s-1.7-13.99-5.1-19.55c-3.4-5.55-8.45-9.91-15.13-13.09-6.69-3.17-15.02-4.76-24.99-4.76-6.8,0-13.15.91-19.04,2.72-5.9,1.82-11,4.99-15.3,9.52-4.31,4.54-7.54,10.6-9.69,18.19-2.16,7.6-3.01,16.95-2.55,28.05l-29.92-4.76c-.68-16.32,1.7-30.6,7.14-42.84,5.44-12.24,14.05-21.7,25.84-28.39C47.49,3.35,62.23,0,79.91,0c15.41,0,28.73,2.5,39.95,7.48,11.22,4.99,19.94,12.19,26.18,21.59,6.23,9.41,9.35,20.57,9.35,33.49,0,10.66-1.82,20.4-5.44,29.24-3.63,8.84-8.22,16.89-13.77,24.14-5.56,7.26-11.68,13.83-18.36,19.72-6.69,5.9-13.21,11.22-19.55,15.98l-63.93,48.96v2.72l126.49-1.02v26.86H0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNum2White);
export default __webpack_public_path__ + "static/media/num_2_white.84ccc1b3138efe4c865513af7848b8af.svg";
export { ForwardRef as ReactComponent };